import ProfileItemForm from "./ProfileItemForm";
import React from "react";
import ProfileCertificationRow from "../../profiles/components/ProfileCertificationRow";

export default class CertificationForm extends ProfileItemForm {

    static ItemType = 'Certification'

    static FormClass = 'talent-role-form add-talent-form add-cert-form '

    static ShowProfilePreview = true;

    static TypeConfig = {
        icon: 'fas fa-award',
        color: TB.config('color.light_purple')
    }

    getModelFromProps() {
        let model = {...(this.props.model || {})};

        if (model.earned_at) {
            if(typeof model.earned_at === 'string') {
                model.earned_at = new Date(model.earned_at)
            }
            model.earned_at_year = model.earned_at.getFullYear();
            model.earned_at_month = model.earned_at.getMonth() + 1;
        }

        return model;
    }

    async onChange(model) {
        await super.onChange({
            ...model,
            ...this.setDateFromInputs(model, 'earned_at')
        });

        let errors = {
            ...this.validateDateBeforeToday('earned_at', 'Earned date')
        };

        if (Object.keys(errors).length) {
            this.formRef.current.updateInputsWithError(errors)
        }
    }

    /**
     * The fields mapping for the form
     */
    formFields = () => {


            // 'certifications.*.name'           => 'required|string|max:255',
            // 'certifications.*.image_path'     => 'nullable|string|max:255', OR 'nullable|image',
            // 'certifications.*.earned_at'      => 'required|string|max:255',
            // 'certifications.*.expires_at'     => 'nullable|string|max:255',
            // 'certifications.*.description'    => 'nullable|string|max:255',

        return [
            {
                style: styles.fieldSection,
                fields: {
                    name: {
                        type: 'text',
                        label: TB.trans('talent.certification_form.certification_name_label'),
                        required: true,
                        maxLength: 255,
                        placeholder: TB.trans('talent.certification_form.certification_name_placeholder'),
                        style: styles.field,
                        columns: 10
                    }
                }
            },

            {
                style: styles.fieldSection,
                fields: {
                    earned_at: {
                        type: 'hidden-date',
                        label: TB.trans('talent.certification_form.earned_date_label'),
                        required: true,
                        style: styles.field,
                        className: 'field hide-input',
                        columns: 10
                    }
                }
            },
            {
                style: styles.fieldSection,
                className: 'field-section field-section-select',
                fields: {
                    earned_at_month: {
                        label: false,
                        placeholder: 'Month',
                        type: 'select',
                        required: false,
                        options: this.monthOptions(),
                        labelClassName: 'hide-label',
                        className: 'field hide-label',
                        style: {...styles.field,  maxWidth: 110, paddingRight: 0},
                    },
                    earned_at_year: {
                        label: false,
                        placeholder: 'Year',
                        type: 'select',
                        required: false,
                        labelClassName: 'hide-label',
                        options: this.yearOptions(),
                        style: {...styles.field,  maxWidth: 110},
                    },
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    image_path: {
                        label: TB.trans('talent.certification_form.certification_logo_label'),
                        type: 'pixie',
                        width: 150,
                        height: 150,
                        maxWidth: 300,
                        ratio: '1:1',
                        circular: false,
                        required: false,
                        style: styles.field,
                        columns: 8
                    },
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    description: {
                        label: TB.trans('talent.certification_form.certification_summary_label'),
                        placeholder: TB.trans('talent.certification_form.certification_summary_placeholder'),
                        type: 'textarea',
                        required: false,
                        style: styles.field,
                        maxLength: 10000,
                        columns: 10,
                        rows: 10
                    },
                }
            },
        ]
    };


    renderProfilePreview() {
        return (
            <div className="px-4 mx-0 self-start">
                <ProfileCertificationRow certification={this.getModelFromProps()}/>
            </div>
        )
    }
}

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};